import { gql } from '@apollo/client';
import { SHOWCASE_FIRM } from './ShowcaseFirm.fragment';

export const SHOWCASE_FIRM_ITEM = gql`
  ${SHOWCASE_FIRM}
  fragment ShowcaseFirmItemFields on showcaseFirmItem {
    id
    description1
    description2
    address
    city
    state
    zip
    line1
    line2
    line3
    url
    imageUrl
    price
    type
    createdBy
    updatedBy
    dateCreated
    dateUpdated
    openHouseStartDate
    openHouseEndDate
    isDeleted
    showcaseFirmId
    representativeId
    firm {
      ...ShowcaseFirmFields
    }
  }
`;
